import React from 'react';

const Close = () => (
	<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.14551 23.6274L23.7729 0.999994" stroke="black" strokeWidth="2" strokeLinecap="round" />
		<path d="M23.7729 23.6976L1.14553 1.07023" stroke="black" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

export default Close;
